import {
    PaymentMethodCreationForm,
    PaymentMethodUpdateForm,
    PaymentMethodViewModel,
    PaymentMethodOptionsBody,
    PaymentMethodOptionViewModel,
    PaymentMethodOptionsResponse,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/finance/payment-method';

export class PaymentMethodApi {
    public static async find(): Promise<PaymentMethodViewModel[]> {
        const { data } = await axios.get(BASE_URL);

        return data.paymentMethods;
    }

    public static async create(params: PaymentMethodCreationForm): Promise<void> {
        await axios.post<PaymentMethodCreationForm>(BASE_URL, params);
    }

    public static async getOptions(params: PaymentMethodOptionsBody): Promise<PaymentMethodOptionViewModel[]> {
        const { data } = await axios.post<PaymentMethodOptionsResponse>(`${BASE_URL}/options`, params);

        return data.paymentMethods;
    }

    public static async update(id: string, params: PaymentMethodUpdateForm): Promise<void> {
        await axios.put<PaymentMethodUpdateForm>(`${BASE_URL}/${id}`, params);
    }

    public static async delete(id: string): Promise<void> {
        await axios.delete(`${BASE_URL}/${id}`);
    }
}

export { BASE_URL as PAYMENT_METHOD_API_BASE_URL };
